import { createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';

import { fetchUserList } from './asyncActions';
import { STORE_NAME, UsersState } from './initialState';

export const userSlice = createSlice({
  name: STORE_NAME,
  initialState: UsersState.INITIAL_DOMAIN,
  reducers: {
    clearUserList: (state) => {
      state.list = UsersState.INITIAL_DOMAIN.list;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserList.fulfilled, (state, action) => {
        state.list = Resource.createResolvedResource({ data: action.payload.data });
        const { pagination } = action.payload;
        state.pagination = {
          limit: pagination.limit,
          page: pagination.page,
          pages: Math.ceil(pagination.total / pagination.limit),
          total: pagination.total,
        };
      })
      .addCase(fetchUserList.rejected, (state, action) => {
        state.list = Resource.createRejectedResource({ error: action.error });
        state.pagination = null;
      });
  },
});

export const { clearUserList } = userSlice.actions;
